import { render, staticRenderFns } from "./BudgetEditor.vue?vue&type=template&id=4793ee3a&"
import script from "./BudgetEditor.vue?vue&type=script&lang=js&"
export * from "./BudgetEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports